import './microsite.scss';
import domready from 'domready';

const $stageHeader = document.querySelector('[data-micrositestage="header"]');
const $stageContent = document.querySelector('[data-micrositestage="content"]');

const checkClaim = (eventScroller) => {
    const stageContentBounding = $stageContent.getBoundingClientRect();
    const stageContentTop = stageContentBounding.top;

    if (stageContentTop <= 0) {
        $stageHeader.classList.add('is--sticky');
    } else {
        $stageHeader.classList.remove('is--sticky');
    }
};

domready(function () {
    const initApplication = () => {
        console.log('microsite');

        if ($stageHeader && $stageContent) {
            const $stageContentText = document.querySelector('[data-micrositestage="text"]');
            if ($stageContentText && $stageHeader) {
                const $clonedText = $stageContentText.cloneNode(true);
                $stageHeader.appendChild($clonedText);
            }

            window.eventScroller.customFunctions.push(() => {
                checkClaim(window.eventScroller);
            });
            checkClaim(window.eventScroller);
        }
    };

    initApplication();
});
